import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { navigateBack } from '../utils/navigationState';

export function useDetailBack(defaultPath) {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    navigateBack(navigate, location, defaultPath);
  }, [navigate, location, defaultPath]);
}
